import type { Store } from 'src/app/models/view-models'
import { NgClass, NgFor, NgIf } from '@angular/common'
import { Component } from '@angular/core'
import { RouterLink, RouterLinkActive } from '@angular/router'
import { NgIconComponent, provideIcons, provideNgIconsConfig } from '@ng-icons/core'
import {
	phosphorCardsThree,
	phosphorCode,
	phosphorDresser,
	phosphorGear,
	phosphorHouse,
	phosphorLifebuoy,
	phosphorMagnifyingGlass,
	phosphorRobot,
	phosphorShirtFolded,
	phosphorShoppingCart,
	phosphorSquaresFour,
	phosphorTag,
} from '@ng-icons/phosphor-icons/regular'
import { AppService, ShopifyService } from 'src/app/services'

@Component({
	selector: 'app-sidebar',
	standalone: true,
	imports: [RouterLink, NgFor, NgIf, RouterLinkActive, NgIconComponent, NgClass],
	templateUrl: './sidebar.component.html',
	styleUrl: './sidebar.component.scss',
	providers: [
		provideIcons({
			phosphorShoppingCart,
			phosphorSquaresFour,
			phosphorMagnifyingGlass,
			phosphorTag,
			phosphorDresser,
			phosphorShirtFolded,
			phosphorCode,
			phosphorHouse,
			phosphorLifebuoy,
			phosphorGear,
			phosphorCardsThree,
			phosphorRobot,
		}),
		provideNgIconsConfig({
			size: '16px',
		}),
	],
})
export class SidebarComponent {
	store: Store
	constructor(private shopifyService: ShopifyService, private appService: AppService) {
		this.appService.getStore().subscribe((data) => {
			this.store = data
		})
	}

	deepLinkUrl() {
		window.open(this.shopifyService.deeplinkInstall(), '_blank')
	}

	intercom() {
		;(window as any)['Intercom']('show')
	}
}
